// react core
import React, { useState, useEffect } from 'react';

// components
import AjaxSpinner from 'components/commons/ajax_spinner';
import QuestionSummary from 'components/questions/question_summary';

// api
import {user_api} from 'commons/api';

export default function Overview({username})
{
    const [isLoaded, setIsLoaded] = useState(false);
    const [userInfo, setUserInfo] = useState({
        'username': '',
        'fullname': '',
        'answers': []
    });

    useEffect(() =>
    {
        setIsLoaded(false);
        let mounted = true;
        const fetchData = async () =>
        {
            const response = await user_api.get_question_by_user(username);
            const result = await response.json();
            if(mounted)
            {
                setIsLoaded(true);
                setUserInfo(result);
            }
        }
        fetchData().catch(console.error);
        return () => mounted = false; // cleanup function
    }, [username]);

    if (!isLoaded)
    {
        return <AjaxSpinner type='inline' />;
    }
    else
    {
        return (
            <div className="questions-list-wrapper">
            {userInfo.answers.length ? userInfo.answers.map(item => (
                <QuestionSummary key={item.id} item={item} highlight={false}/>
            )) : <p>User has not ansked any questions</p>}
            </div>
        );
    }
};
